export enum ETimeGridYAxisType {
  DATE = "DATE",
  DEVICE = "DEVICE",
}
